module.exports = __webpack_public_path__ + "static/cocogothic-bolditalic-webfont-05aa86f18436a86eef3a634673826fc9.woff";